import { render, staticRenderFns } from "./notificationDetailDefaultForm.vue?vue&type=template&id=39dbe1c9"
import script from "./notificationDetailDefaultForm.vue?vue&type=script&lang=js"
export * from "./notificationDetailDefaultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports